import { createAjaxAction } from '../../Common/_actions/AjaxAction';
import { createAction } from '../../Common/_actions/Action';
import { Dispatch } from 'redux';
import Library from '../../Resource/Library';
import { PatternDesignImage } from '../PatternDesignServiceLibrary';
import * as Immutable from 'immutable';
import { EditLoader } from '../../UIData/_actions/UIDataActions';

export enum PatternActionType {
	OnPatternDesignServiceImageAdd		= "ON_PATTERN_DESIGN_SERVICE_IMAGE_ADD",
	OnPatternDesignServiceCategoryAdd	= "ON_PATTERN_DESIGN_SERVICE_CATEGORY_ADD",
	OnPatternDesignServiceSetColors		= "ON_PATTERN_DESIGN_SERVICE_SET_COLORS",
	OnSelectCategory					= "ON_PATTERN_DESIGN_SERVICE_SELECT_CATEGORY",
	OnResetPatterns						= "ON_PATTERN_DESIGN_SERVICE_RESET_PATTERNS",
	OnPatternDesignServiceOffsetChange	= "ON_PATTERN_DESIGN_SERVICE_OFFSET_CHANGE",
}

const OnPatternDesignServiceImageAdd = (id: string, name: string, src: string, recolorable: boolean, categoryId: number) => createAction(PatternActionType.OnPatternDesignServiceImageAdd, {
	id: id,
	name: name,
	src: src,
	recolorable: recolorable,
	categoryId: categoryId
});

const OnPatternDesignServiceCategoryAdd = (id: number, title: string, thumbnail: string, categories: Array<{}>) => createAction(PatternActionType.OnPatternDesignServiceCategoryAdd, {
	id: id,
	title: title,
	thumbnail: thumbnail,
	categories: categories,
});

const OnPatternDesignServiceSetColors = (id: string, colors: Array<string>) => createAction(PatternActionType.OnPatternDesignServiceSetColors, {
	id: id,
	colors: colors
});

export const OnSelectCategory = (id: string) => createAction(PatternActionType.OnSelectCategory, {
	id: id
});

export const OnResetPatterns = () => createAction(PatternActionType.OnResetPatterns);

export const GetPatterns = (categoryId: string, search: string, limit: number, offset: number) => {
	return createAjaxAction({
		url: "ajax/create/get-pattern-designs?categoryId="+categoryId+"&search="+search+"&limit="+limit+"&offset="+offset,
		method: "GET",
		onSuccess: (response, dispatch) => {
			dispatch(OnResetPatterns());
			let images:PatternDesignImage[] = response.data.images.map(
				(image:any, index:number) => ({
					id: image.id, 
					name: image.title, 
					src: image.thumbnails.xlargeDiscreet.url, 
					recolorable: image.metadata.recolorable,
					index: index,
					categoryId: +categoryId,
				}) as PatternDesignImage
			);

			if(images.length) {
				let first = true;
				images.map((image:any) => {
					Library.PatternDesignServiceLibrary.retrieve(image).then((image: PatternDesignImage) => {
						first = first ? dispatch(EditLoader("patterns", false)) && false : false;
						dispatch(OnPatternDesignServiceImageAdd(image.id, image.name, image.src, image.recolorable, image.categoryId))
					});
				});
			} else {
				dispatch(EditLoader("patterns", false))
			}
		}
	});
};

export const GetPatternColors = (id: string, callback: Function) => {
	return createAjaxAction({
		url: "ajax/create/get-pattern-colors?id="+id,
		method: "GET",
		onSuccess: (response, dispatch) => {
			let colors = response.data.colors;
			colors.map((color:string, i:number) => {
				colors[i] = '#'+color;
			});

			dispatch(OnPatternDesignServiceSetColors(id, colors));
			if(callback) {
				callback(Immutable.OrderedSet<string>(colors));
			}
		}
	});
};

export const GetPatternCategories = () => createAjaxAction({
	url: "ajax/create/get-pattern-categories",
	method: "GET",
	onSuccess: (response, dispatch) => {
		response.data.categories.map((category:any) => {
			dispatch(OnPatternDesignServiceCategoryAdd(category.id, category.title, category.thumbnail, category.categories));
		});
	}
});

export const RecolorPattern = (id: string) => createAjaxAction({
	url: "ajax/create/recolor-pattern?id="+id,
	method: "GET",
	onSuccess: (response, dispatch) => {
		response.data.images.map((image:any) => {
			Library.PatternDesignServiceLibrary.retrieve({id: image.id, name: image.title, src: image.thumbnails.xlargeDiscreet.url, recolorable: image.recolorable, categoryId: image.categoryId}).then((image: PatternDesignImage) => {
				dispatch(OnPatternDesignServiceImageAdd(image.id, image.name, image.src, image.recolorable, image.categoryId))
			});
		});
	}
});

export const OnPatternDesignServiceOffsetChange = (offset: number) => createAction(PatternActionType.OnPatternDesignServiceOffsetChange, {
	offset: offset
});

export type PatternAction = 
	ReturnType<typeof OnPatternDesignServiceImageAdd> |
	ReturnType<typeof OnPatternDesignServiceCategoryAdd> |
	ReturnType<typeof OnPatternDesignServiceSetColors> |
	ReturnType<typeof OnSelectCategory> |
	ReturnType<typeof OnResetPatterns> |
	ReturnType<typeof GetPatterns> |
	ReturnType<typeof GetPatternCategories> |
	ReturnType<typeof GetPatternColors> |
	ReturnType<typeof OnPatternDesignServiceOffsetChange>